import { http } from '@common/utils';
import { trackPromise } from 'react-promise-tracker';
import { ServiceHelper } from './serviceHelper';
import { ServiceMethodOptions } from './types';
import {
  IHospitalSalesItemFavoritesModel,
  HospitalSalesItemFavoritesModel,
} from '@common/models/HospitalSalesItemFavoritesModel';

export class HospitalSalesItemFavoritesService {
  private static baseUrl: string = '/api/hospitalsalesitemfavorites';

  public static tags = {
    addHospitalSalesItemFavorite: 'addHospitalSalesItemFavorite',
    deleteHospitalSalesItemFavorite: 'deleteHospitalSalesItemFavorite',
  };

  public static addHospitalSalesItemFavorite = (
    request: IHospitalSalesItemFavoritesModel,
    options?: ServiceMethodOptions,
  ): Promise<HospitalSalesItemFavoritesModel> => {
    return trackPromise(
      new Promise<HospitalSalesItemFavoritesModel>((resolve, reject) => {
        http(this.baseUrl)
          .post<IHospitalSalesItemFavoritesModel>(request)
          .then((data) => {
            try {
              const favorite = new HospitalSalesItemFavoritesModel(data);
              resolve(favorite);
            } catch (err) {
              reject(err);
            }
          })
          .catch((error) => {
            ServiceHelper.showError(
              `${error.message} Failed to favorite item.`,
              options,
            );
            reject(error);
          });
      }),
      ServiceHelper.getTagForOptions(
        this.tags.addHospitalSalesItemFavorite,
        options,
      ),
  );
};

  public static deleteHospitalSalesItemFavorite = (
    hospitalId: number,
    salesItemOptionId: number,
    options?: ServiceMethodOptions,
  ): Promise<void> => {
    return trackPromise(
      new Promise<void>((resolve, reject) => {
        http(
          `${this.baseUrl}?hospitalId=${hospitalId}&salesItemOptionId=${salesItemOptionId}`,
        )
          .delete()
          .then(() => resolve())
          .catch((error) => {
            ServiceHelper.showError(
              `${error.message} Failed to unfavorite item.`,
              options,
            );
            reject(error);
          });
      }),
      ServiceHelper.getTagForOptions(
        this.tags.deleteHospitalSalesItemFavorite,
        options,
      ),
    );
  };
}
